export const Theme = {
    darkBackground: '#0d0f0d',
    mediumBackground: '#111411',
    lightBackground: '#1c211c',
    lightForegroundColor: '#b2f7be',
    mediumForegroundColor: '#75a07c',
    darkForegroundColor: '#2d3d2f',
    matrixColor: '#3b4f3d',
    veryDarkForegroundColor: '#1e2820',
    overlayColor: 'rgba(15, 25, 16, .85)',
    codeColor: '#eefc32',
    linkColor: '#c05ec9',
    visitedLinkColor: '#803b87',
};
